import React from 'react'
import ProjectParking from '../components/ProjectParking'
const AddParking = ({ setStep }) => {
  return (
    <ProjectParking setStep={setStep} />
  )
}

export default AddParking
